import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import {
  GetConfigReq, GetConfigResp, DelRepositoryReq, drRepository, GetRepositoryListReq, GetRepositoryListResp, SetRepositoryReq, SetRepositoryResp,
  drMicroEvent, GetMicroEventsReq, GetMicroEventsResp, MicroEventResp, SetMicroEventReq, ErrorResp, UploadReq, UploadResp, GetMicroEventReq, SendFormReq
} from '@robisoft/cross-library';
import { DateTime } from 'luxon';
import { lastValueFrom } from 'rxjs';
import { UtilsService } from 'src/app/services/utils.service';
import { AppSettings } from 'src/app/app.settings';

@Injectable({
  providedIn: 'root'
})

export class CrossCpService {

  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
    Pragma: 'no-cache'
  });
  constructor(private http: HttpClient,
    private utils: UtilsService) { }

  public async getConfig(myToken: string, endpoint: string, code: string, note: string, id: number, guid: string): Promise<GetConfigResp | undefined> {
    let resp: GetConfigResp | undefined = new GetConfigResp();

    if (!myToken) {
      resp.error = "myToken is null";
      return resp;
    }

    try {
      let req = new GetConfigReq();
      req.myToken = myToken;
      req.id = id;
      req.guid = guid;
      req.code = code;
      req.note = note;
      resp = await lastValueFrom(this.http.post<GetConfigResp>(endpoint + '/cp/get_config', req, { headers: this.headers }));
      if (!resp)
        resp = new GetConfigResp();

    } catch (err: any) {
      if (err && resp)
        resp.error = String(err);
    }
    return resp;
  }

  public async getRepositoryList(endpoint: string, req: GetRepositoryListReq): Promise<GetRepositoryListResp> {

    let resp: GetRepositoryListResp | undefined = new GetRepositoryListResp();
    try {
      resp = await lastValueFrom(this.http.post<GetRepositoryListResp>(endpoint + '/cp/get_repository_list', req, { headers: this.headers }));

      if (!resp) {
        resp = new GetRepositoryListResp();
        resp.error = 'Non riesco a collegarmi al server (get_repository_list)';
        return resp;
      }

      if (resp.repositories) {
        resp.repositories.forEach((repo) => {
          Object.setPrototypeOf(repo, drRepository.prototype);
        });
        if (resp.repositories) {
          resp.repositories.forEach(rep => {
            rep.D.forEach((d, i) => {
              if (rep.D[i]) {
                rep.D[i] = DateTime.fromISO(rep.D[i]!.toString());
              }
              if (rep.PublishingDate)
                rep.PublishingDate = DateTime.fromISO(rep.PublishingDate!.toString());
              if (rep.ExpiryDate)
                rep.ExpiryDate = DateTime.fromISO(rep.ExpiryDate!.toString());

            });
          });
        }
      } else {
        resp.repositories = [];
      }
    } catch (err) {
      if (!resp) {
        resp = new GetRepositoryListResp();
      }
      resp.error = 'Non riesco a collegarmi al server (get_contact) ' + err;
    }
    return resp;
  }

  public async setRepository(endpoint: string, req: SetRepositoryReq): Promise<SetRepositoryResp> {

    let resp: SetRepositoryResp | undefined = new SetRepositoryResp();

    try {

      resp = await lastValueFrom(this.http.post<SetRepositoryResp>(endpoint + '/cp/set_repository', req, { headers: this.headers }));

      if (!resp) {
        resp = new SetRepositoryResp();
        resp.error = 'Non riesco a collegarmi al server (set_repository)';
        return resp;
      }

      if (resp && resp.repository) {
        resp.repository.D.forEach((d, i) => {
          if (d) {
            d = DateTime.fromISO(d!.toString());
          }
        });
        if (resp.repository.PublishingDate)
          resp.repository.PublishingDate = DateTime.fromISO(resp.repository.PublishingDate!.toString());
        if (resp.repository.ExpiryDate)
          resp.repository.ExpiryDate = DateTime.fromISO(resp.repository.ExpiryDate!.toString());
      }

    } catch (err) {
      if (!resp) {
        resp = new SetRepositoryResp();
      }
      resp.error = 'Non riesco a collegarmi al server (set_repository) ' + err;
    }
    return resp;
  }

  public async deleteRepository(endpoint: string, req: DelRepositoryReq): Promise<ErrorResp> {

    let resp: ErrorResp | undefined = new ErrorResp();

    try {

      resp = await lastValueFrom(this.http.post<ErrorResp>(endpoint + '/cp/del_repository', req, { headers: this.headers }));

      if (!resp) {
        resp = new ErrorResp();
        resp.error = 'Non riesco a collegarmi al server (del_repository)';
        return resp;
      }

    } catch (err) {
      if (!resp) {
        resp = new ErrorResp();
      }
      resp.error = 'Non riesco a collegarmi al server (del_repository) ' + err;
    }
    return resp;
  }

  public async getMicroEvents(endpoint: string, req: GetMicroEventsReq): Promise<GetMicroEventsResp> {

    let resp: GetMicroEventsResp | undefined = new GetMicroEventsResp();
    try {

      resp = await lastValueFrom(this.http.post<GetMicroEventsResp>(endpoint + '/cp/get_micro_events', req, { headers: this.headers }));

      if (!resp) {
        resp = new GetMicroEventsResp();
        resp.error = 'Non riesco a collegarmi al server (get_micro_events)';
        return resp;
      }

      if (resp.microEvents) {
        resp.microEvents.forEach((me: drMicroEvent) => {
          for (let i = 0; i < me.D.length; i++) {
            if (me.D[i])
              me.D[i] = DateTime.fromISO(me.D[i]!.toString());
          }
        });
      }

    } catch (err) {
      if (!resp) {
        resp = new GetMicroEventsResp();
      }
      resp.error = 'Non riesco a collegarmi al server (get_micro_events) ' + err;
    }
    return resp;
  }

  public async getMicroEvent(endpoint: string, req: GetMicroEventReq): Promise<MicroEventResp> {

    let resp: MicroEventResp | undefined = new MicroEventResp();

    try {

      resp = await lastValueFrom(this.http.post<MicroEventResp>(AppSettings.API_ENDPOINT + '/cp/get_micro_event', req, { headers: this.headers }));

      if (resp && resp.microEvent) {
        for (let i = 0; i < resp.microEvent.D.length; i++) {
          if (resp.microEvent.D[i])
            resp.microEvent.D[i] = DateTime.fromISO(resp.microEvent.D[i]!.toString());
        }
      }
    } catch (err) {
      resp.error = 'Non riesco a collegarmi al server (get_micro_events) ' + err;
    }
    return resp;
  }

  public async setMicroEvent(endpoint: string, req: SetMicroEventReq): Promise<MicroEventResp> {

    let resp: MicroEventResp | undefined = new MicroEventResp();
    try {

      resp = await lastValueFrom(this.http.post<MicroEventResp>(endpoint + '/cp/get_micro_events', req, { headers: this.headers }));

      if (!resp) {
        resp = new MicroEventResp();
        resp.error = 'Non riesco a collegarmi al server (get_micro_events)';
        return resp;
      }

      if (resp.microEvent) {
        for (let i = 0; i < resp.microEvent.D.length; i++) {
          if (resp.microEvent.D[i])
            resp.microEvent.D[i] = DateTime.fromISO(resp.microEvent.D[i]!.toString());
        }
      }

    } catch (err) {
      if (!resp) {
        resp = new MicroEventResp();
      }
      resp.error = 'Non riesco a collegarmi al server (get_micro_events) ' + err;
    }
    return resp;
  }

  public async deleteMicroEvent(endpoint: string, req: GetMicroEventReq): Promise<ErrorResp> {

    let resp: ErrorResp | undefined = new ErrorResp();

    try {

      resp = await lastValueFrom(this.http.post<ErrorResp>(endpoint + '/cp/delete_micro_event', req, { headers: this.headers }));

      if (!resp) {
        resp = new ErrorResp();
        resp.error = 'Non riesco a collegarmi al server (delete_micro_event)';
        return resp;
      }

    } catch (err) {
      if (!resp) {
        resp = new ErrorResp();
      }
      resp.error = 'Non riesco a collegarmi al server (delete_micro_event) ' + err;
    }
    return resp;
  }

  async uploadFile2(endpoint: string, aws: boolean, req: UploadReq): Promise<UploadResp> {

    let resp: UploadResp | undefined = new UploadResp();

    try {

      if (aws)
        resp = await lastValueFrom(this.http.post<UploadResp>(endpoint + '/aws/upload_file', req, { headers: this.headers }));
      else
        resp = await lastValueFrom(this.http.post<UploadResp>(endpoint + '/cp/upload_file', req, { headers: this.headers }));

      if (!resp) {
        resp = new UploadResp();
        resp.error = 'Non riesco a collegarmi al server (upload_file)';
      }

    } catch (err) {
      if (!resp) {
        resp = new UploadResp();
      }
      resp.error = 'Non riesco a collegarmi al server (upload_file) ' + err;
    }
    return resp;
  }

  async sendForm(endpoint: string, req: SendFormReq): Promise<ErrorResp> {
    let resp: ErrorResp | undefined = new ErrorResp();
    try {
      resp = await this.http.post<ErrorResp>(endpoint + '/cp/send_form', req, { headers: this.headers }).toPromise();
      if (!resp) {
        resp = new ErrorResp();
        resp.error = 'Non riesco a collegarmi al server (upload_file)';
      }
    } catch (err) {
      if (!resp) {
        resp = new ErrorResp();
      }
      this.utils.showError('errors.connecting');
    }
    if (resp && resp.error !== '') {
      this.utils.showError(resp.error);
    }
    return resp;
  }

}
